import { ProjectPhase } from "../../../constants/project-phase";
import { ProjectDates } from "../../../models";
import { SearchWorkflowTasksResponse } from "../../../service/query";
import { ServiceError } from "../../../service/Shared";

export const isDeadlineOutsidePhase = (
  milestone: SearchWorkflowTasksResponse["results"][0],
  dates: ProjectDates,
  deadlineDate?: Date
): ServiceError | undefined => {
  let isOutside = false;
  // in default, set isOutside as 'false'.
  // If there isn't a deadline date, then we should not triggering errors.
  if (deadlineDate) {
    switch (milestone.step?.phase) {
      case ProjectPhase.feasibility:
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        isOutside = !(deadlineDate >= dates.feasibility.start! && deadlineDate <= dates.feasibility.end!);
        break;
      case ProjectPhase.design:
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        isOutside = !(deadlineDate >= dates.design.start! && deadlineDate <= dates.design.end!);
        break;
      case ProjectPhase.implementation:
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        isOutside = !(deadlineDate >= dates.implementation.start! && deadlineDate <= dates.implementation.end!);
        break;
      case ProjectPhase.ongoingMonitoring:
        isOutside = !(
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          (deadlineDate >= dates.ongoingMonitoring.overallStart! && deadlineDate <= dates.ongoingMonitoring.overallEnd!)
        );
        break;
      default:
        break;
    }
  }
  return isOutside
    ? {
        message: `${milestone.name} has a deadline outside of the ${milestone.step?.phase} phase start and end dates.`,
        code: "MILESTONE_DEADLINE_OUTSIDE_PHASE",
      }
    : undefined;
};
